<template>
    <div>
        <b-card-text class="textBotao">
       
        Conheça as vantagens do Protesto de Títulos como opção de recuperação de crédito!
        O Protesto de Títulos é 60% mais eficientes que os outros métodos de recuperação de crédito! Clique e saiba mais!
        </b-card-text>
    </div>
</template>
<script>
export default {
    
}
</script>
<style>

</style>